<template>
  <div
    :class="['menu-search', `menu-search-${layoutFrame}`]"
    :style="wrapStyle"
  >
    <AInput class="menu-search-input" v-bind="inputProps" v-model:value="key">
      <template #prefix v-if="['classicBlue','technology'].includes(layoutFrame)">
        <ATooltip title="搜索菜单">
          <SearchOutlined @click="onSearch" style="cursor: pointer;" />
        </ATooltip>
      </template>
      <template #suffix v-else>
        <ATooltip title="搜索菜单">
          <SearchOutlined @click="onSearch" style="cursor: pointer" />
        </ATooltip>
      </template>
    </AInput>
  </div>
</template>

<script setup lang="ts">
import type { CSSProperties } from 'vue'
import { InputProps } from 'ant-design-vue'
import {
  SearchOutlined
} from '@ant-design/icons-vue'
import GoingUtils from '@/utils/goingUtils'
import { usePermissionStore } from '@/store/modules/permission'
import { dbUtils } from 'xmgoing-utils'
import { useAppFrame } from '@/hooks/useAppFrame'
const { layoutFrame } = useAppFrame()

const props = defineProps<{
  /** 固定宽度（如头部菜单主题下 180px），不传则铺满容器 */
  width?: number
}>()

const PermissionStore = usePermissionStore()

const key = ref()
const name = ref()

const wrapStyle = computed<CSSProperties | undefined>(() => {
  if (!props.width) return undefined
  return {
    width: `${props.width}px`,
    flex: `0 0 ${props.width}px`,
  }
})

const inputProps = computed<Partial<InputProps>>(() => {
  return {
    placeholder: '请输入菜单名称进行搜索',
    allowClear: true,
    style: { width: '100%' },
    onPressEnter: () => {
      onSearch()
    }
  }
})

async function onSearch () {
  name.value = key.value
  GoingUtils.showLoading()
  dbUtils.clearUserMenus()
  try {
    await PermissionStore.buildRoutesAction(name.value)

    sessionStorage.setItem('menuSearchKey', name.value || '')

    await nextTick()

    PermissionStore.setLastBuildMenuTime()
  } finally {
    GoingUtils.closeLoading()
  }
}

onMounted(() => {
  const menuSearchKey = sessionStorage.getItem('menuSearchKey')
  if (menuSearchKey) {
    key.value = menuSearchKey
  }
})
</script>

<style lang="less" scoped>
.menu-search {
  padding: 8px;
  flex: 0 0 auto;
}

.menu-search-classicBlue {
  padding: 25px 8px 15px 8px;
  flex: 0 0 auto;
  .menu-search-input{
    background: #1F58A7;
    border-radius: 4px;
    border: 1px solid #BBCDE4;
    .ant-input-prefix{
      color: #BBCDE4;
      margin-right: 12px;
    }
    :deep(.ant-input){
      background: #1F58A7;
      color: #BBCDE4;
    }
    :deep(.ant-input-prefix){
      color: #BBCDE4;
      margin-right: 4px;
    }
    :deep(.ant-input-clear-icon){
      color: #FFF;
    }
  }
}


.menu-search-technology {
  padding: 25px 8px 15px 8px;
  flex: 0 0 auto;
  .menu-search-input{
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    .ant-input-prefix{
      color: #CCCCCC;
      margin-right: 12px;
    }
    :deep(.ant-input){
      background: #FFFFFF;
      color: #CCCCCC;
    }
    :deep(.ant-input-prefix){
      color: #CCCCCC;
      margin-right: 4px;
    }
    :deep(.ant-input-clear-icon){
      color: #CCCCCC;
    }
  }
}
</style>
